<template>
  <v-list-item :style="THEME_CSS_VARS" class="sms-contact-container">
    <slot name="counter"></slot>
    <v-list-item-avatar size="32" class="sms-contact-avatar">
      <slot name="avatar"></slot>
    </v-list-item-avatar>
    <v-list-item-content :class="!showActions ? 'sms-contact-content-full-width' : ''" class="sms-contact-content">
      <v-list-item-title class="sms-contact-title">
        <slot name="title"></slot>
      </v-list-item-title>
      <v-list-item-subtitle class="sms-contact-subtitle">
        <slot name="subtitle"></slot>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action :class="!showActions ? 'd-none' : ''" class="sms-contact-actions">
      <slot name="actions"></slot>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import ThemeMixin from '@/mixins/ThemeMixin';

export default {
  name: 'SmsListItem',

  mixins: [ThemeMixin],

  props: {
    showActions: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.sms-contact-container:hover {
  background: var(--v-side-item-hover-base);
}
.sms-contact-container {
  cursor: pointer;
  min-height: 50px;
  width: 100%;
}
.sms-contact-avatar {
  margin: 9px 8px 9px 0px !important;
  font-size: 12px;
}
.sms-contact-content {
  padding: 5px 0 !important;
}
.sms-contact-content-full-width {
  width: calc(100% - 40px) !important; /* 40 px from avatar: 32 size + 8 margin-right*/
}

.sms-contact-container:hover .sms-contact-title,
.sms-conversation-container-active .sms-contact-title,
.sms-contact-container:hover .sms-contact-subtitle,
.sms-conversation-container-active .sms-contact-subtitle {
  color: var(--font-color) !important;
}

.sms-contact-title {
  font-size: 0.9rem !important;
}

.sms-contact-subtitle {
  font-size: 0.8rem !important;
  color: var(--subtitle-font-color) !important;
}

.sms-contact-actions {
  margin: 9px 0 9px 8px !important;
}
</style>
